import type { TFunction } from "i18next"

import type { IDeviceWRelsById } from "types/device.types"

import { getTelemetryTranslation } from "helpers/utils/translations"

const getFromToDeviceLabelFromSeriesId = (
  seriesId: string,
  devsWRelsById: IDeviceWRelsById | undefined,
  t: TFunction,
) => {
  const parts = JSON.parse(seriesId)
  const fromId = parts.from_id
  const toId = parts.to_id
  const field = parts._field
  const fromName = devsWRelsById?.[fromId]?.device?.name || ""
  const toName = devsWRelsById?.[toId]?.device?.name || ""
  const fieldLabel = getTelemetryTranslation(field, t)

  return fromName && toName ? `${fieldLabel}: ${fromName} → ${toName}` : fieldLabel
}

const getFieldAndDeviceNameLabelFromSeriesId = (
  seriesId: string,
  devsWRelsById: IDeviceWRelsById | undefined,
  t: TFunction,
) => {
  const parts = JSON.parse(seriesId)
  const id = parts.id
  const field = parts._field
  const deviceName = devsWRelsById?.[id]?.device?.name || ""
  const fieldLabel = getTelemetryTranslation(field, t)
  return deviceName ? `${fieldLabel}: ${deviceName}` : fieldLabel
}

const getFieldLabelFromSeriesId = (seriesId: string, t: TFunction) => {
  const parts = JSON.parse(seriesId)
  return getTelemetryTranslation(parts._field as string, t)
}

export const getTowerTooltipLabel = (
  seriesId: string,
  labelType: "fromTo" | "fieldDevice" | "field",
  devsWRelsById: IDeviceWRelsById | undefined,
  t: TFunction,
) => {
  if (labelType === "field") return getFieldLabelFromSeriesId(seriesId, t)
  return labelType === "fromTo"
    ? getFromToDeviceLabelFromSeriesId(seriesId, devsWRelsById, t)
    : getFieldAndDeviceNameLabelFromSeriesId(seriesId, devsWRelsById, t)
}
